import { patchState, signalStore, withMethods, withState } from "@ngrx/signals";

export interface UserStore {
    loading: boolean
    clinic_id: number
    provider_id: number
    id: number,
    onboarding_status: number,
    user_group: string[],
    active: boolean
    licence_expire_date: string | null
    license_expire_date: string | null
    insurance_expire_date: string | null
    has_expired_documents: boolean
}

const initialState: UserStore = {
    loading: false,
    clinic_id: 0,
    provider_id: 0,
    onboarding_status: 0,
    id: 0,
    active: false,
    user_group: [],
    licence_expire_date: null,
    license_expire_date: null,
    insurance_expire_date: null,
    has_expired_documents: false
}

export const UserStore = signalStore(
    { providedIn: 'root', protectedState: false},
    withState(initialState),
    withMethods((store) => {
        return {
            setLoading(loading: boolean) {
                patchState(store, { loading })
            },
            setParams(params: any) {
                patchState(store, {...params})
            },
            setClinicId(clinic_id: number) {
                patchState(store, { clinic_id })
            },
            setProviderId(provider_id: number) {
                patchState(store, { provider_id})
            },
            setOnboardingStatus(onboarding_status: number) {
                patchState(store, {onboarding_status})
            },
            setUserGroup(user_group: string[]) {
                patchState(store, { user_group})
            },
            setExpiryDates(params: {
                licence_expire_date?: string | null,
                license_expire_date?: string | null,
                insurance_expire_date?: string | null,
                has_expired_documents?: boolean
            }) {
                patchState(store, {
                    licence_expire_date: params.licence_expire_date ?? params.license_expire_date ?? null,
                    license_expire_date: params.license_expire_date ?? params.licence_expire_date ?? null,
                    insurance_expire_date: params.insurance_expire_date ?? null,
                    has_expired_documents: params.has_expired_documents ?? false
                })
            }
        }
    })
)
